// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sift-tutorial .ant-notification-notice-message {\n  color: #2F5598;\n}", "",{"version":3,"sources":["webpack://./src/components/Tutorial/tutorial.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","sourcesContent":[".sift-tutorial .ant-notification-notice-message {\n  color: #2F5598;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
